import { FunctionComponent, h } from 'preact';

import { links } from '../constants';

import { Markdown } from '../components/Markdown';
import { Title } from '../components/title';
import { Carousel } from '../components/Carousel';
import { Quote } from '../components/quote';
import { Section } from '../components/Grid';
import { StarRating } from '../components/StarRating';
import { TestimonialWithQuote } from './Trustpilot';

export type Rating = {
    name: string;
    primary?: boolean;
    rating: number;
};

type Props = {
    quotes: TestimonialWithQuote[];
    ratings: Rating[];
    className: string;
};

const Testimonials: FunctionComponent<Props> = ({ quotes = [], ratings, className }) => (
    <div className={className}>
        <Section className="u-pb-0">
            <header className="u-text-center">
                <Title className="u-mb-4 md:u-mb-6" inverted>
                    <span>A best-in-class</span>
                    <span>experience</span>
                </Title>
                <p className="u-mb-6 sm:u-font-4">
                    90% of our users rate us as Excellent on{' '}
                    <a href={links.HUGO_TRUSTPILOT} target="_blank" rel="noreferrer noopener">
                        Trustpilot.
                    </a>
                </p>
            </header>

            <table className="c-star-rating-table">
                <thead>
                    <tr>
                        <th></th>
                        <th>Aug’22 Trustpilot rating </th>
                    </tr>
                </thead>
                <tbody>
                    {ratings.map((r, i) => (
                        <tr key={i}>
                            <td>
                                <Markdown content={r.name} />
                            </td>
                            <td>
                                <StarRating rating={r.rating} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="u-text-center u-mb-12 md:u-font-3">
                <a href={links.HUGO_TRUSTPILOT} target="_blank" rel="noreferrer noopener">
                    See more on Trustpilot
                </a>
            </div>
        </Section>
        {quotes.length > 0 && (
            <Carousel className="u-pb-12 sm:u-mb-4 l-container">
                {quotes.map((quoteProps, index) => (
                    <Quote key={index} {...quoteProps} />
                ))}
            </Carousel>
        )}
    </div>
);

export default Testimonials;
